import { render, staticRenderFns } from "./Empregado.vue?vue&type=template&id=9a6f9846"
import script from "./Empregado.vue?vue&type=script&lang=js"
export * from "./Empregado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports